import { ANYTHING, CacheScenario, CacheTime, EndpointToClean, MethodType } from 'app/models/api/cache';
import { API_ENDPOINT } from './utils.service';

const allMachinesChangingEndpoints: () => EndpointToClean[] = (): EndpointToClean[] => [
  {
    url: `${API_ENDPOINT}/machines`,
    method: MethodType.POST
  },
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}`,
    method: MethodType.PUT
  },
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}/maintenance`,
    method: MethodType.PUT
  },
  {
    url: `${API_ENDPOINT}/machines/delete`,
    method: MethodType.POST
  },
  {
    url: `${API_ENDPOINT}/machines/duplicate`,
    method: MethodType.POST
  }
];
const allMachineTasksChangingEndpoints: () => EndpointToClean[] = (): EndpointToClean[] => [
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}`,
    method: MethodType.PUT
  },
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}/schedules`,
    method: MethodType.POST
  },
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}/schedules/update`,
    method: MethodType.POST
  },
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}/schedules/flexible`,
    method: MethodType.POST
  },
  {
    url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}/schedules/flexible/update`,
    method: MethodType.POST
  }
];

export const machinesServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'getMachines',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/machines`,
      method: MethodType.GET
    },
    cleaningEndpoints: allMachinesChangingEndpoints()
  },
  // get machine by id endpoint,
  // as we use this endpoint to get data related to tasks and it s schedules and translations
  {
    description: 'getMachine',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/machines/${ANYTHING}`,
      method: MethodType.GET
    },
    cleaningEndpoints: [...allMachinesChangingEndpoints(), ...allMachineTasksChangingEndpoints()]
  },
  {
    description: 'getMachinesBriefData',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/machines/select`,
      method: MethodType.GET
    },
    cleaningEndpoints: allMachinesChangingEndpoints()
  },
  {
    description: 'getMachineIds',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/machines/ids`,
      method: MethodType.GET
    },
    cleaningEndpoints: allMachinesChangingEndpoints()
  },
  // caching get of all machines tags
  {
    description: 'getTags',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/filters/tags`,
      method: MethodType.GET
    },
    cleaningEndpoints: allMachinesChangingEndpoints()
  }
];
